import React from "react";
import { connect } from "react-redux";
import { Permissioned } from "react-permissions";
import Util from "../../util/util";
import QuickLinksMenu from "./QuickLinksMenu";

class QuickLinks extends React.Component {
  render() {
    const { menu } = this.props;
    return (
      <div key={menu.key}>
        {menu.subMenus && menu.subMenus.length ? (
          <div className="col-sm-4">
            <div className="panel panel-arbiter-blue">
              <div className="panel-heading">
                <h4 className="p-0 m-0">
                  <i
                    className={menu.iconClass || "ion ion-ios-circle-filled"}
                  />{" "}
                  {menu.title}
                </h4>
              </div>
              <div className="panel-body p-0">
                <div className="list-group mb-0">
                  {menu.subMenus.map((subMenu) => (
                    <QuickLinksMenu
                      id={`${subMenu.key}-submenu-item`}
                      location={this.props.location}
                      allowedPermissions={subMenu.permissions}
                      key={subMenu.key}
                      subMenu={subMenu}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(Permissioned(QuickLinks));



// WEBPACK FOOTER //
// ./src/components/dashboard/Quicklinks.js